<template>
	<el-tabs>
		<el-tab-pane >
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>
			<div style="padding: 20px;">
				<el-input v-model="value.wenzi" placeholder="请输入内容"> <template slot="prepend">内容</template></el-input>
				<el-input v-model="value.wenzi" placeholder="请输入内容"> <template slot="prepend">内容</template></el-input>
			</div>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<!-- <el-input placeholder="请输入内容" v-model="value.yangshi.gao">
				<template slot="prepend">Http://</template>
			</el-input> -->
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	export default {
		name: 'sousuo_bianji',
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},

	}
</script>
<link rel="stylesheet" href="Yangshi.css">
